import { useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { quickSearchFocusState, quickSearchState } from '../recoil/atoms';

export const FilterEffects = () => {
  const quickSearch = useRecoilValue(quickSearchState);
  const setQuickSearchFocus = useSetRecoilState(quickSearchFocusState);

  useEffect(() => {
    setQuickSearchFocus(quickSearch.length > 0);
  }, [quickSearch]);

  return <></>;
};
